import {
  Box,
  Button,
  CircularProgress,
  CssBaseline,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import logoigt from "../../assets/logoigt.png";
import "../../css/pages/login.css";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, loginUser } from "../../features/user/userSlice";
import * as CryptoJS from "crypto-js";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const [loginMsg, setloginMsg] = useState("");
  const [username, setUserName] = useState("");
  const [pwd, setPassword] = useState("");
  const key = CryptoJS.enc.Utf8.parse("bwplAPVp1OH7Xzyr");
  const iv = CryptoJS.enc.Utf8.parse("bwplAPVp1OH7Xzyr");
  const navigate = useNavigate();

  const { loading, loggedIn, user, error } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    const encryptedPwd = CryptoJS.AES.encrypt(pwd, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const password = encryptedPwd.toString();

    dispatch(loginUser({ username: username, password: password }));
  };

  useEffect(() => {
    if (localStorage.getItem("userCredential")) {
      navigate("/dashboard");
    }
  }, [loggedIn]);

  useEffect(() => {
    dispatch(clearErrors());
  }, [dispatch]);

  return (
    <Grid className="signin pt-10">
      {loading ? (
        <CircularProgress></CircularProgress>
      ) : (
        <>
          <Grid
            sx={{ borderRadius: "4px" }}
            item
            xs={8}
            md={4}
            component={Paper}
            elevation={3}
            className="auth-card"
          >
            <Box
              sx={{
                margin: "64px 32px",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Box sx={{ maxWidth: "00px", marginBottom: "20px" }}>
                <img src={logoigt} alt="logo" style={{ width: "100%" }} />
              </Box>
              <Typography
                component="h1"
                variant="h5"
                style={{ color: "#585858" }}
              >
                Sign Into Your Account
              </Typography>
              <Box
                sx={{
                  width: {
                    xs: "100%",
                    sm: "400px",
                  },
                }}
              >
                <form onSubmit={handleSubmit}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    name="email"
                    label="Email Address"
                    value={username}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="password"
                    name="password"
                    label="Password"
                    type="password"
                    value={pwd}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      mt: 1,
                    }}
                  >
                    <Link
                      to="/forgot-password"
                      style={{
                        textDecoration: "none",
                        color: "#1976d2",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      Forgot Password?
                    </Link>
                  </Box>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{ padding: "10px 16px", marginTop: "12px" }}
                  >
                    Sign In
                  </Button>
                </form>
              </Box>

              {error && (
                <div>
                  <p className="loginMsg">{error}</p>
                </div>
              )}
            </Box>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Login;
